import { initializeApp } from "firebase/app";

import {
  collection,
  addDoc,
  serverTimestamp,
  getFirestore,
  onSnapshot,
  query,
  orderBy,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

import firebaseConfig from "config/firebase.dev.json";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

async function sendMessage(room, firebaseId, text) {
  // room is "mentor" or "mentee"
  try {
    await addDoc(collection(db, room, firebaseId, "messages"), {
      message: text,
      sentByUser: false,
      createdAt: serverTimestamp(),
    });
    updateUser(room, firebaseId, {
      lastMessage: text,
      lastMessageTime: serverTimestamp(),
    });
  } catch (error) {
    console.error(error);
  }
}

async function getUsers(room, callback) {
  // const docRef = collection(db, room);
  // const docSnap = await getDocs(docRef);
  // const users = [];
  // docSnap.forEach((doc) => users.push(doc.data()));
  // return users;

  try {
    onSnapshot(
      query(collection(db, room), orderBy("lastMessageTime", "desc")),
      (querySnapshot) => {
        const users = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        callback(users, false);
      },
      (error) => {
        callback(null, error);
      }
    );
  } catch (error) {
    callback(null, error.message);
  }
}

async function updateUser(room, firebaseId, user) {
  // room is "mentor" or "mentee"
  const docRef = doc(db, room, firebaseId);
  await updateDoc(docRef, user);
}

function getMessages(room, firebaseId, callback) {
  updateUser(room, firebaseId, {
    unseen: 0,
  });

  return onSnapshot(
    query(
      collection(db, room, firebaseId, "messages"),
      orderBy("createdAt", "asc")
    ),
    (querySnapshot) => {
      const messages = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      callback(messages);
    }
  );
}

async function deleteUser(room, firebaseId, user) {
  // room is "mentor" or "mentee"

  const docRef = doc(db, room, firebaseId);
  await deleteDoc(docRef, user);
}

export { sendMessage, getMessages, getUsers, updateUser, deleteUser };
